export const locale = {
    lang: 'ds',
    data: {
        'STATUS': {
            'Created': 'lavet',
            'Updated': 'Opdateret',
            'Deleted': 'Slettet',
            'FileUploaded': 'Fil uploadet',
            'FileDeleted': 'Fil slettet',
            'Email': 'Email',
        },
        'TITLE': {
            'CustomerPagination': 'Antal lager pr. side',
        },
        'BUTTONS': {
            'BACK': 'Gå tilbage',
            'BTNSAVE': 'Gem',
            'Add': 'Tilføj',
        },
        'FIELDS': {
            'SRNO': 'Sr nr.',
            'Status': 'Status',
            'Number': 'Antal',
            'Name': 'Navn',
            'Createdby': 'OprettetAf',
            'CreatedDate': 'OprettetDato',
            'ModifyBy': 'ModificereAf',
            'ModifyDate': 'ModificereDato',
            'CoworkerName': 'Medarbejder',
            'Date': 'Dato',
            'Description': 'Tekst',
            'Action': 'Handling',
            "Materialtype": 'Vare type',
            'All': 'Alle',
            'Material': 'Lager',
            'Price':'pris'
        },
        'Headers': {
        },
        'MESSAGES': {
            'NORECORD': 'Ingen registrering fundet',
            'MaterialAdded': 'Debitor Lager Tilføjet.',
            'MaterialAddFailed': 'Handlingen mislykkedes, prøv senere.',
            'DeleteAlert': 'Er du sikker på, at du vil slette?',
            'MaterialDeleted': 'Debitor Lager Slettet.',
            'MaterialDeleteFailed': 'Handlingen mislykkedes, prøv senere.',
        },
        'TOOTIPORTITLE':{
            'IsActive':'Er Aktiv',
            'IsDeleted':'Er Slettet',
            'DeleteMaterial':'Slet Materiale'
        }
    }
};
